import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Construction, X, ArrowRight } from "lucide-react";

const STORAGE_KEY = "roadrig.devbanner.dismissed";

export const DevStatusBanner = () => {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    setDismissed(localStorage.getItem(STORAGE_KEY) === "1");
  }, []);

  if (dismissed) return null;

  const close = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setDismissed(true);
  };

  return (
    <div
      data-testid="dev-status-banner"
      role="status"
      className="relative z-[60] w-full bg-[#0A0A0C] border-b border-[#F47A20]/25"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#F47A20]/60 to-transparent" />
      <div className="max-w-7xl mx-auto px-4 md:px-12 py-2.5 md:py-2 flex items-center gap-3">
        <span className="flex-shrink-0 inline-flex items-center justify-center w-6 h-6 rounded-sm bg-[#F47A20]/12 border border-[#F47A20]/30">
          <Construction size={12} className="text-[#F47A20]" />
        </span>

        <p data-testid="dev-status-banner-text" className="flex-1 text-[11px] md:text-[12px] text-white/75 leading-snug">
          <span className="serial text-[#F47A20] font-bold tracking-[0.2em] uppercase mr-2">In Development</span>
          <span className="hidden sm:inline">ROADRIG is currently in active development. The OUTLAW V1 is being refined through real-world testing, factory collaboration and rider feedback.</span>
          <span className="sm:hidden">ROADRIG is in active development. OUTLAW V1 prototype is being refined.</span>
        </p>

        <Link
          to="/coming-soon"
          data-testid="dev-status-banner-cta"
          className="hidden md:inline-flex items-center gap-1.5 text-[11px] tracking-[0.2em] uppercase font-bold text-[#F47A20] hover:text-white transition-colors flex-shrink-0"
        >
          Join VIP <ArrowRight size={12} />
        </Link>

        <button
          data-testid="dev-status-banner-dismiss"
          onClick={close}
          aria-label="Dismiss development banner"
          className="flex-shrink-0 text-white/40 hover:text-white transition-colors p-1"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
};

export default DevStatusBanner;
